import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { PATTERNS } from "../../../util/patterns";
import { GetCountryListAndInternationalSupport } from "../../../util/countryListAndInternationalSupport";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import * as common from "../../../util/common";
import { registerPageUserData } from "../DisplayOption";
import { STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION } from "../ReCompleteRegistrationUtil";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { isValidPhoneNo } from "../../../util/phoneNumberValidationUtil";
import { useButtonText } from "../../commonConstants";
import { sendRequest } from "../../../util/httpClient";
import { Helmet } from "react-helmet";
import DeviceVerificationError from '../../Registration/DeviceVerificationError';
interface IProps {
    registrationLookup?: any;
    setReCompleteRegistrationState?: any;
}

const PersonalInformationForm = ({ registrationLookup, setReCompleteRegistrationState }: IProps) => {
    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const partnerDisplayName: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );
    const { register, handleSubmit, errors, watch, control } = useForm({
        mode: "onBlur",
    });
    const [memberAgeError, setMemberAgeError] = useState(false);
    const [negativeAgeError, setNegativeError] = useState(false);
    let { supportInternational } = GetCountryListAndInternationalSupport();
    const minimumMemberAge = 18;

    const [state, setState] = useState({
        SSN: registrationLookup.SSN ? registrationLookup.SSN : "",
        confirmSSN: registrationLookup.confirmSSN ? registrationLookup.confirmSSN : "",
        ssn1: registrationLookup.SSN ? registrationLookup.SSN.substring(0, 3) : "",
        ssn2: registrationLookup.SSN ? registrationLookup.SSN.substring(3, 5) : "",
        ssn3: registrationLookup.SSN ? registrationLookup.SSN.substring(5) : "",
        cssn1: registrationLookup.confirmSSN ? registrationLookup.confirmSSN.substring(0, 3) : "",
        cssn2: registrationLookup.confirmSSN ? registrationLookup.confirmSSN.substring(3, 5) : "",
        cssn3: registrationLookup.confirmSSN ? registrationLookup.confirmSSN.substring(5) : "",
        confirmSNNError: false,
    });
    const [loading, setLoading] = useState(false);
    const [showDeviceVerificationError, setShowDeviceVerificationError] = useState(false);
    const [deviceVerificationStatus, setDeviceVerificationStatus] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        sendRequest("GET", "web/DeviceRisk/GetDeviceActivationStatus").then((deviceVerificationResponse: any) => {
            setDeviceVerificationStatus(deviceVerificationResponse);
            sessionStorage.setItem('activateDeviceVerificationFlag', deviceVerificationResponse);
        });
    }, []);
    const isNextOrContinue = useButtonText()[0];
    let birthDateFieldPressedKey: number;
    const updatBirthDatePressedKey = (e: any) => {
        birthDateFieldPressedKey = e.keyCode;
    };

    const send_bb = () => {
        var blackbox = "";
        try {
            blackbox = window.IGLOO.getBlackbox().blackbox;
        } catch (e) { }
        return blackbox;
    };

    const onSubmit = (personalInfo: any) => {
        setLoading(true);
        let country = "";
        if (personalInfo && !personalInfo.country) {
            country = "US";
        } else {
            country = personalInfo.country;
        }

        if (state.confirmSSN !== state.SSN) {
            setState({
                ...state,
                confirmSNNError: true,
            });
            return;
        }
        if (memberAgeError) return;
        if (negativeAgeError) return;
        if (deviceVerificationStatus) {
            const blackBoxKey = send_bb();
            const checkDeviceRiskRequestBody = {
                blackbox: blackBoxKey,
                email: personalInfo["email"],
                partnerDisplayName: partnerDisplayName,
                country: country,
                source: "web",
                type: "registration",
                registrastionType: 'RECOMPLETE'
            }
            sendRequest("POST", "web/DeviceRisk/CheckDeviceRisk", checkDeviceRiskRequestBody).then((deviceRiskData: any) => {
                window.addToDataLayer({ event: "NEXT-BUTTON-PERSONAL-INFO-CLICK" });

                if (deviceRiskData["hasError"]) {
                    window.addToDataLayer({ event: "DEVICE_VERIFICATION_API_FAILURE" });
                } else {
                    window.addToDataLayer({ event: "DEVICE_VERIFICATION_API_SUCCESS" });
                }
                
                if (deviceRiskData.result && deviceRiskData.result.toLowerCase() === 'd') {
                    window.addToDataLayer({ event: "DEVICE_VERIFICATION_DENY_RESULT" });
                    setShowDeviceVerificationError(true);
                    setLoading(false);
                } else {
                    if (deviceRiskData.result) {
                        if (deviceRiskData.result.toLowerCase() === 'r') {
                            window.addToDataLayer({ event: "DEVICE_VERIFICATION_REVIEW_RESULT" });
                        } else if (deviceRiskData.result.toLowerCase() === 'a') {
                            window.addToDataLayer({ event: "DEVICE_VERIFICATION_ALLOW_RESULT" });
                        }
                    }

                    setLoading(false);
                    setReCompleteRegistrationState({
                        ...registrationLookup,
                        step: STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION,
                        firstName: personalInfo.FirstName,
                        lastName: personalInfo.LastName,
                        phone: personalInfo.phoneNumber,
                        SSN: state.SSN,
                        confirmSSN: state.confirmSSN,
                        dob: personalInfo.dob,
                    });
                    window.addToDataLayer({ event: "ENROLLMENT-STEP-2" });
                }
            }).catch((error: Error): any => {
                window.addToDataLayer({ event: "NEXT-BUTTON-PERSONAL-INFO-CLICK" });
                window.addToDataLayer({ event: "DEVICE_VERIFICATION_API_FAILURE" });

                setLoading(false);
                setReCompleteRegistrationState({
                    ...registrationLookup,
                    step: STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION,
                    firstName: personalInfo.FirstName,
                    lastName: personalInfo.LastName,
                    phone: personalInfo.phoneNumber,
                    SSN: state.SSN,
                    confirmSSN: state.confirmSSN,
                    dob: personalInfo.dob,
                });
                window.addToDataLayer({ event: "ENROLLMENT-STEP-2" });
            });
        } else {
            window.addToDataLayer({ event: "NEXT-BUTTON-PERSONAL-INFO-CLICK" });
            window.addToDataLayer({ event: "DEVICE_VERIFICATION_DEACTIVATED" });
            setLoading(false);
            setReCompleteRegistrationState({
                ...registrationLookup,
                step: STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION,
                firstName: personalInfo.FirstName,
                lastName: personalInfo.LastName,
                phone: personalInfo.phoneNumber,
                SSN: state.SSN,
                confirmSSN: state.confirmSSN,
                dob: personalInfo.dob,
            });
            window.addToDataLayer({ event: "ENROLLMENT-STEP-2" });
        }
    };

    const getDefaultEmailValue = () => {
        return registrationLookup && registrationLookup.email ? registrationLookup.email : "";
    };

    const checkMemberAge = (date: string) => {
        try {
            const accountDOBinDateFormate = new Date(date);
            const age = common.calculate_age(accountDOBinDateFormate);
            const todaysDate = new Date();

            if (age < minimumMemberAge) {
                setMemberAgeError(true);
            } else {
                setMemberAgeError(false);
            }

            if (todaysDate < accountDOBinDateFormate) {
                setNegativeError(true);
            } else {
                setNegativeError(false);
            }
        } catch {
            setMemberAgeError(false);
            setNegativeError(false);
        }
    };

    function onChangeHandler(event: any) {
        if ((event.target.value.length === 2 || event.target.value.length === 5) && birthDateFieldPressedKey !== 8 && birthDateFieldPressedKey !== 46) {
            event.target.value = event.target.value + "/";
        }
        checkMemberAge(event.currentTarget.value);
    }

    const getDefaultFirstName = () => {
        return registrationLookup && registrationLookup.firstName ? registrationLookup.firstName : "";
    };

    const getDefaultLastName = () => {
        return registrationLookup && registrationLookup.lastName ? registrationLookup.lastName : "";
    };

    const getCountryInfo = () => {
        let currentCountry = accountInfo && accountInfo.country ? accountInfo.country : "";
        let isCountry = watch("country") && (watch("country").includes("US") || watch("country").includes("CA"));
        if ((currentCountry.includes("US") || currentCountry.includes("CA")) && isCountry) {
            return false;
        } else if (!supportInternational || isCountry) {
            return false;
        } else {
            return true;
        }
    };

    const handleSSN1 = (event: any) => {
        const ssn1 = event.target.value;
        const SSN = ssn1 + state.ssn2 + state.ssn3;

        setState({
            ...state,
            ssn1,
            SSN,
            confirmSNNError: false,
        });

        if (ssn1.length > 2) {
            document.getElementById("ssn2")?.focus();
        }
    };

    const handleSSN2 = (event: any) => {
        const ssn2 = event.target.value;
        const SSN = state.ssn1 + ssn2 + state.ssn3;

        setState({
            ...state,
            ssn2,
            SSN,
            confirmSNNError: false,
        });

        if (ssn2.length > 1) {
            document.getElementById("ssn3")?.focus();
        }
    };

    const handleSSN3 = (event: any) => {
        const ssn3 = event.target.value;
        const SSN = state.ssn1 + state.ssn2 + ssn3;

        setState({
            ...state,
            ssn3,
            SSN,
            confirmSNNError: false,
        });

        if (ssn3.length > 3) {
            document.getElementById("cssn1")?.focus();
        }
    };

    const handleCSSN1 = (event: any) => {
        const cssn1 = event.target.value;
        const confirmSSN = cssn1 + state.cssn2 + state.cssn3;

        setState({
            ...state,
            cssn1,
            confirmSSN,
            confirmSNNError: false,
        });

        if (cssn1.length > 2) {
            document.getElementById("cssn2")?.focus();
        }
    };

    const handleCSSN2 = (event: any) => {
        const cssn2 = event.target.value;
        const confirmSSN = state.cssn1 + cssn2 + state.cssn3;

        setState({
            ...state,
            cssn2,
            confirmSSN,
            confirmSNNError: false,
        });

        if (cssn2.length > 1) {
            document.getElementById("cssn3")?.focus();
        }
    };

    const handleCSSN3 = (event: any) => {
        const cssn3 = event.target.value;
        const confirmSSN = state.cssn1 + state.cssn2 + cssn3;

        setState({
            ...state,
            cssn3,
            confirmSSN,
            confirmSNNError: false,
        });
    };

    useEffect(() => {
        const el = document.getElementsByClassName("PhoneInputCountry");
        if (el && el.length > 0) {
            try {
                const childs = el[0].children;
                if (childs[0].nodeName === "SELECT") {
                    const selectEl = childs[0] as HTMLSelectElement;
                    selectEl.disabled = true;
                }
            } catch {}
        }
    }, [accountInfo]);

    const listData = registerPageUserData.personalUserData;

    return (
        <>
            {showDeviceVerificationError ?
                <DeviceVerificationError /> :
                <div className="row" id="content">
                <div className="col-xs">
                    <div className="box box-has-shadow offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName={"user"} />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">{listData.step1.title1}</h2>
                                </div>
                            </div>
                        </div>
                        <div className={loading ? "box-content loading" : "box-content"}>
                            <form onSubmit={handleSubmit(onSubmit)} id="register-personal-info-1">
                                <div className="row between-sm">
                                    <div className="col-xs-12 col-sm-7 col-no-gutter">
                                        <p>Complete each step by entering your information in the required fields.</p>
                                        <div className="margin-bottom-l"></div>

                                        <div role="grid" className="data-grid">
                                            <div role="row" className="data-row row">
                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-label" id="label-primary-email-1">
                                                        Primary Email
                                                    </div>
                                                </div>
                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="data-value">
                                                        <label htmlFor="label-primary-email" className="hide-label">Primary Email</label>
                                                        <input
                                                            type="text"
                                                            className="inputbox"
                                                            id="label-primary-email"
                                                            placeholder="Email Address"
                                                            name="email"
                                                            readOnly={true}
                                                            defaultValue={getDefaultEmailValue()}
                                                            ref={register({
                                                                required: true,
                                                                pattern: PATTERNS.EMAIL.pattern,
                                                            })}
                                                        />
                                                        {!!errors["email"] && errors["email"].type === "required" && (
                                                            <span className="form-error">Email is required</span>
                                                        )}
                                                        {!!errors["email"] && errors["email"].type === "pattern" && (
                                                            <span className="form-error">{PATTERNS.EMAIL.message}</span>
                                                        )}
                                                        {!!errors["email"] && errors["email"].type === "isEmailExist" && (
                                                            <span className="form-error">
                                                                Email address already exists. Perhaps you need to login or use a different email address.
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <fieldset className="form-row inline">
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <legend className="legend-label"> <label htmlFor="label-first-name">Full Name</label></legend>
                                                </div>
                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="row">
                                                        <div className="col-xs-12 col-no-gutter">
                                                            <div className={`form-row row ${errors["FirstName"] && "status-error"}`}>
                                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                    <label htmlFor="label-first-name-1">First Name</label>
                                                                </div>
                                                                <div className="form-input col-xs-12 col-no-gutter">
                                                                    <input
                                                                        type="text"
                                                                        name="FirstName"
                                                                        className="inputbox"
                                                                        id="label-first-name"
                                                                        placeholder="First Name"
                                                                        maxLength={30}
                                                                        defaultValue={getDefaultFirstName()}
                                                                        ref={register({ pattern: PATTERNS.FIRSTNAME.pattern, required: true })}
                                                                    />
                                                                    {!!errors["FirstName"] && errors["FirstName"].type === "pattern" && (
                                                                        <span className="form-error">{PATTERNS.FIRSTNAME.message}</span>
                                                                    )}
                                                                    {!!errors["FirstName"] && errors["FirstName"].type === "required" && (
                                                                        <span className="form-error">First name is required</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="row">
                                                        <div className="col-xs-12 col-no-gutter">
                                                            <div className={`form-row row ${errors["LastName"] && "status-error"}`}>
                                                                <div className="form-label sr-only col-xs-12 col-no-gutter">
                                                                    <label htmlFor="label-last-name">Last Name</label>
                                                                </div>
                                                                <div className="form-input col-xs-12 col-no-gutter">
                                                                    <input
                                                                        type="text"
                                                                        name="LastName"
                                                                        className="inputbox"
                                                                        maxLength={30}
                                                                        id="label-last-name"
                                                                        placeholder="Last Name"
                                                                        defaultValue={getDefaultLastName()}
                                                                        ref={register({ pattern: PATTERNS.LASTNAME.pattern, required: true })}
                                                                    />
                                                                    {!!errors["LastName"] && errors["LastName"].type === "pattern" && (
                                                                        <span className="form-error">{PATTERNS.LASTNAME.message}</span>
                                                                    )}
                                                                    {!!errors["LastName"] && errors["LastName"].type === "required" && (
                                                                        <span className="form-error">Last name is required</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <fieldset className="form-row inline">
                                            <div className="row">
                                                <div className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <legend className="legend-label"> <label htmlFor="label-phone-number">Mobile Number</label></legend>
                                                </div>

                                                <div className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="row ">
                                                        <div className="col-xs-12 col-no-gutter">
                                                            <div
                                                                className={`form-row row ${errors["phoneNumber"] && "status-error"} ${errors["phoneNumber"] && watch("phoneNumber") && !parsePhoneNumber(watch("phoneNumber"))
                                                                        ? "country-error"
                                                                        : ""
                                                                    }`}
                                                            >
                                                                <div className="form-label sr-only col-xs-12  col-no-gutter">
                                                                    <label htmlFor="label-phone-number-1">Number </label>
                                                                </div>
                                                                <div className="form-input col-xs-12  col-no-gutter">
                                                                    <Controller
                                                                        name={`phoneNumber`}
                                                                        control={control}
                                                                        defaultValue={
                                                                            registrationLookup && registrationLookup.phone ? registrationLookup.phone : ""
                                                                        }
                                                                        className="inputbox"
                                                                        rules={{
                                                                            required: true,
                                                                            validate: (value) =>
                                                                                value
                                                                                    ? isValidPhoneNo(
                                                                                        registrationLookup && registrationLookup.country
                                                                                            ? registrationLookup.country
                                                                                            : "US",
                                                                                        value
                                                                                    )
                                                                                    : false,
                                                                        }}
                                                                        render={({ onChange, value }) => (
                                                                            <PhoneInput
                                                                                value={value}
                                                                                onChange={onChange}
                                                                                international={false}
                                                                                addInternationalOption={false}
                                                                                defaultCountry={
                                                                                    registrationLookup && registrationLookup.country
                                                                                        ? registrationLookup.country
                                                                                        : accountInfo && accountInfo.country
                                                                                            ? accountInfo.country
                                                                                            : "US"
                                                                                }
                                                                                countries={[
                                                                                    registrationLookup && registrationLookup.country
                                                                                        ? registrationLookup.country
                                                                                        : accountInfo && accountInfo.country
                                                                                            ? accountInfo.country
                                                                                            : "US",
                                                                                ]}
                                                                                id="label-phone-number"
                                                                                placeholder="Enter Mobile number"
                                                                                maxLength={15}
                                                                                minLength={10}
                                                                            />
                                                                        )}
                                                                    />
                                                                    {!!errors["phoneNumber"] && errors["phoneNumber"].type === "required" && (
                                                                        <span className="form-error">Mobile is required</span>
                                                                    )}
                                                                    {!!errors["phoneNumber"] && errors["phoneNumber"].type === "validate" && (
                                                                        <span className="form-error">Invalid format. Please enter a valid mobile number.</span>
                                                                    )}
                                                                    {!!errors["phoneNumber"] &&
                                                                        errors["phoneNumber"].type === "minLength" &&
                                                                        (getCountryInfo() ? (
                                                                            <span className="form-error">
                                                                                Mobile Number must be a minimum of 7 digits in length.
                                                                            </span>
                                                                        ) : (
                                                                            <span className="form-error">
                                                                                Invalid format. Please enter a 10-digit mobile number, in the following format: (888)
                                                                                123-4567.
                                                                            </span>
                                                                        ))}
                                                                    {!!errors["phoneNumber"] &&
                                                                        errors["phoneNumber"].type === "maxLength" &&
                                                                        (getCountryInfo() ? (
                                                                            <span className="form-error">
                                                                                Mobile Number must be a maximum of 15 digits in length.
                                                                            </span>
                                                                        ) : (
                                                                            <span className="form-error">
                                                                                Invalid format. Please enter a 10-digit mobile number, in the following format: (888)
                                                                                123-4567.
                                                                            </span>
                                                                        ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>

                                        <div className={`form-row inline row`}>
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="ssn1">Social Security</label>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="form-input row">
                                                        <div className={`col-xs-4 col-no-gutter ${errors["ssn1"] && "status-error"}`}>
                                                            <input
                                                                type="password"
                                                                maxLength={3}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.ssn1}
                                                                onChange={handleSSN1}
                                                                name="ssn1"
                                                                id="ssn1"
                                                                ref={register({ pattern: /[\d]{3}/, required: true })}
                                                            />
                                                        </div>
                                                        <div className={`col-xs-3 col-gutter-horizontal ${errors["ssn2"] && "status-error"}`}>
                                                            <label htmlFor="ssn2" className="hide-label">Social Security &nbsp;</label>
                                                            <input
                                                                type="password"
                                                                maxLength={2}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.ssn2}
                                                                onChange={handleSSN2}
                                                                name="ssn2"
                                                                id="ssn2"
                                                                ref={register({ pattern: /[\d]{2}/, required: true })}
                                                            />
                                                        </div>
                                                        <div className={`col-xs-5 col-no-gutter ${errors["ssn3"] && "status-error"}`}>
                                                            <label htmlFor="ssn3" className="hide-label">Social Security &nbsp; &nbsp;</label>
                                                            <input
                                                                type="password"
                                                                maxLength={4}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.ssn3}
                                                                onChange={handleSSN3}
                                                                name="ssn3"
                                                                id="ssn3"
                                                                ref={register({ pattern: /[\d]{4}/, required: true })}
                                                            />
                                                        </div>
                                                        {(errors["ssn1"] || errors["ssn2"] || errors["ssn3"]) && (
                                                            <span className="form-error">Please enter valid Social Security Number.</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className={`form-row inline row ${(state.confirmSNNError || errors["cssn1"] || errors["cssn2"] || errors["cssn3"]) && "status-error"
                                                }`}
                                        >
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="cssn1">Confirm Social Security</label>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                <div className="row">
                                                    <div className="form-input row">
                                                        <div className="col-xs-4 col-no-gutter">
                                                            <input
                                                                type="password"
                                                                maxLength={3}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.cssn1}
                                                                onChange={handleCSSN1}
                                                                name="cssn1"
                                                                id="cssn1"
                                                                ref={register({ pattern: /[\d]{3}/, required: true })}
                                                            />
                                                        </div>
                                                        <div className="col-xs-3 col-gutter-horizontal">
                                                            <label htmlFor="cssn2" className="hide-label">Confirm Social Security &nbsp;</label>
                                                            <input
                                                                type="password"
                                                                maxLength={2}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.cssn2}
                                                                onChange={handleCSSN2}
                                                                name="cssn2"
                                                                id="cssn2"
                                                                ref={register({ pattern: /[\d]{2}/, required: true })}
                                                            />
                                                        </div>
                                                        <div className="col-xs-5 col-no-gutter">
                                                            <label htmlFor="cssn3" className="hide-label">Confirm Social Security &nbsp;&nbsp;</label>
                                                            <input
                                                                type="password"
                                                                maxLength={4}
                                                                className="inputbox"
                                                                autoComplete="off"
                                                                defaultValue={state.cssn3}
                                                                onChange={handleCSSN3}
                                                                name="cssn3"
                                                                id="cssn3"
                                                                ref={register({ pattern: /[\d]{4}/, required: true })}
                                                            />
                                                        </div>
                                                    </div>
                                                    {(errors["cssn1"] || errors["cssn2"] || errors["cssn3"]) && (
                                                        <span className="form-error">Please enter valid Confirm Social Security Number.</span>
                                                    )}
                                                    {!(errors["cssn1"] || errors["cssn2"] || errors["cssn3"]) && state.confirmSNNError && (
                                                        <span className="form-error">Your Social Security Numbers do not match.</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`form-row inline row ${(errors["dob"] || memberAgeError || negativeAgeError) && "status-error"}`}>
                                            <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                                <label htmlFor="dob">Date of Birth</label>
                                            </div>
                                            <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                                <input
                                                    type="text"
                                                    name="dob"
                                                    defaultValue={registrationLookup.dob}
                                                    className="inputbox"
                                                    id="dob"
                                                    onKeyDown={updatBirthDatePressedKey}
                                                    onChange={onChangeHandler}
                                                    ref={register({
                                                        required: true,
                                                        pattern: /^(([0][1-9]|1[012])[/]([0][1-9]|[12][0-9]|3[01])[/](18|19|20|21)?[0-9]{4})*$/,
                                                        maxLength: 10,
                                                    })}
                                                    maxLength={10}
                                                    placeholder="MM/DD/YYYY"
                                                />
                                                {errors["dob"] && errors["dob"].type === "required" && (
                                                    <span className="form-error">Date of Birth is required.</span>
                                                )}
                                                {errors["dob"] && errors["dob"].type === "pattern" && (
                                                    <span className="form-error">Invalid format. Date of Birth should be MM/DD/YYYY.</span>
                                                )}
                                                {negativeAgeError && <span className="form-error">Please enter valid date. The given date is future date.</span>}
                                                {memberAgeError && <span className="form-error">Member must be {minimumMemberAge} years old or older.</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="margin-vertical-l"></div>

                                <div className="row between-xs">
                                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                                    <div className="col-xs col-no-gutter flex-grow-null">
                                        <ul className="list-inline list-reset">
                                            <li className="margin-left-s">
                                                <button
                                                    type="submit"
                                                    className="btn-default btn-primary btn-min-width"
                                                    onClick={() => window.addToDataLayer({ event: "Next Button PersonalInformation Click" })}
                                                >
                                                    <span className="btn-text">{isNextOrContinue}</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            }
            {deviceVerificationStatus ?
                <Helmet>
                    <script src="js/config.js" type="text/javascript" ></script>
                    <script src="js/loader_only.js" type="text/javascript" ></script>
                </Helmet> :
                null
            } 
        </>
    );
};

export default PersonalInformationForm;
